import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

const Communicator: React.FC<RouteComponentProps> = (props) => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <h2>Coming Soon</h2>
    </div>
  )
}

export default Communicator;
